import Glide from '@glidejs/glide'

export default class IAGlide {
    constructor(element, options) {
        this.instance = new Glide(element).mount(options)
    }
}